/** One prompt per capability a new user may not guess the agent has. */
export const GETTING_STARTED_PROMPTS = [
  'Show me the latest clear imagery of this property and what changed since last summer.',
  'Which properties in this portfolio changed the most this year?',
  'Draft a note about what you see at the north boundary and put it on the map.',
];

export interface ChatPreset {
  title: string;
  description: string;
  prompts: readonly string[];
}

/** Ways to start a chat from the Automations page; the chat's canvas then offers the preset's prompts. */
export const CHAT_PRESETS = {
  'order-imagery': {
    title: 'Find & order imagery',
    description: 'Find suitable scenes for your properties and fill your cart.',
    prompts: [
      'Put the most recent, cloud-free submeter image from each property in the Easements portfolio into my cart.',
      'Help me find the best imagery to order for leaf-off visibility.',
    ],
  },
  'new-structures': {
    title: 'Identify new structures',
    description: 'Compare high-res imagery and outline new buildings.',
    prompts: [
      'Detect new structures on all properties in the Easements portfolio.',
      'Count the buildings on a property in its latest high-resolution image.',
    ],
  },
  changes: {
    title: "Describe what's changed",
    description: 'Compare imagery across properties and generate draft observations.',
    prompts: [
      'Describe changes between two truecolor scenes.',
      'Which properties in the Easements portfolio changed the most this year?',
    ],
  },
  'vegetation-disturbance': {
    title: 'Track vegetation disturbance',
    description: 'Flag NDVI drops outside the expected seasonal range.',
    prompts: [
      'Which properties in the Easements portfolio had an unseasonal vegetation drop this year?',
      'Chart NDVI on a property over the last two years and point out drops outside its usual seasonal range.',
    ],
  },
  'from-document': {
    title: 'Start from a document',
    description: 'Upload a protocol or spreadsheet and turn it into an automation.',
    prompts: [
      'Here is our monitoring protocol. What does it ask us to check, and how would Lens do it?',
      'This spreadsheet lists the easement year per property. Find the best high-resolution imagery from that year for each one.',
    ],
  },
} satisfies Record<string, ChatPreset>;

type ChatPresetKey = keyof typeof CHAT_PRESETS;

export function chatPreset(key: string | null | undefined): ChatPreset | null {
  return key && Object.prototype.hasOwnProperty.call(CHAT_PRESETS, key)
    ? CHAT_PRESETS[key as ChatPresetKey]
    : null;
}
